import enhance from './MembershipInfoContainer';
import CustomerMembershipInfo from './MembershipInfo';

export default enhance(CustomerMembershipInfo);
